<template>

	<div class="report_container full" v-loading="loading" element-loading-background="rgba(255, 255, 255, 0.3)">
		<vxe-grid class="" v-bind="gridOptions" :key="gridKey" v-if="gridOptions"
			@toolbar-button-click="toolbarButtonClickEvent" :ref="reportName+'_list'">
		</vxe-grid>

		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />


		<exportTable :ref="exportRef" :forms="forms" :tableColumn="tableColumn" :reportName="reportName"
			:windowName="windowName" :afterexport="afterexport" listType="report" />

		<vxe-modal v-model="exportNoticeShow" show-footer @show="onExportNoticeShow"
			:before-hide-method="beforeExportNoticeClose" height="600" width="500">
			<template #title>
				<span>导出面板</span>
			</template>
			<template #default>
				<template v-if="forms.length!=0">
					<el-divider content-position="left">表单</el-divider>
					<vxe-checkbox-group class="group" v-model="exportForms" size="mini">
						<vxe-checkbox v-for="(item,index) in forms" :key="index" :label="item.label"
							:content="item.title" :disabled="item.type=='main'"></vxe-checkbox>
					</vxe-checkbox-group>
				</template>
				<el-divider content-position="left">数据</el-divider>
				<el-radio-group class="group" v-model="exportType" size="mini">
					<el-radio-button label="current" border>当前数据</el-radio-button>
					<el-radio-button label="total" border>所有数据</el-radio-button>
				</el-radio-group>

				<template v-for="(item,index) in exportConfig">
					<div :key="index">
						<el-divider content-position="left">{{item.title}}</el-divider>
						<el-radio-group v-model="exportFieldType" size="mini" class="group"
							@change="exportFieldTypeChange" v-if="item.type=='column'">
							<el-radio-button v-for="(item) in exportConbineColumn" :key="item.label" :label="item.label"
								border>{{item.title}}</el-radio-button>
						</el-radio-group>
						<vxe-checkbox-group v-model="item.select" size="mini" @change="exportColumnChange">
							<vxe-checkbox style="width: 30%;margin-left: 10px;margin-bottom: 4px;"
								v-for="(_item,_index) in item.data" :label="_item.id" :content="_item.label"
								:key="_index">
							</vxe-checkbox>
						</vxe-checkbox-group>
					</div>
				</template>
			</template>
		</vxe-modal>
	</div>
</template>
<style>

</style>
<style scoped>
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	import exportMixins from '@_system/components/base/mixins/list/export.js'
	import reportBase from '@_system/components/base/report.js'
	import exportTable from '@_system/components/export/index.vue'
	export default {
		mixins: [reportBase, exportMixins],
		name: 'report',
		props: {

		},
		data() {
			return {
				footerField: [{
					type: 'seq',
					field: 'code',
					title: '汇总',
				}, {
					type: 'field',
					field: 'recordnum',
					toFixed: 0
				}, {
					type: 'field',
					field: 'successnum',
					toFixed: 0
				}],
				showFooter: true,
				reportName: 'invoicecustomerorder',
				windowName: '自动开票明细',
				exportRef: Math.random(),
				loading: false,
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig, columns, gridOptions) {
				gridOptions.pagerConfig.enabled = false
			},
		},
		components: {
			exportTable,
		
		}
	}
</script>
